module.exports = __webpack_public_path__ + "img/영국 국기.59b3ac31.png";